import { ContactsLastImportId } from 'modules/contacts/contacts-import/types/contacts-import-interface'

export const getInvalidContactsLastImportAllData = (contactsLastImportId: ContactsLastImportId) =>
  `/api/dashboard/contact/contacts/import/${contactsLastImportId}/download-all-data`
